// WorkPage.jsx
import React from 'react';
import SIMOMIMO from '../Asset/SIMOMIMO.jpg'
import second from '../Asset/second.jpg'
import third from '../Asset/third.jpg'
import fourth from '../Asset/fourth.jpg'
import fifth from '../Asset/fifth.jpg'
import six from '../Asset/six6.jpg'
// Replace the required info 
const works = [
  {
    title: 'Project on SISO, SIMO, MISO, and MIMO 2022',
    description: 'Multi-Antenna Techniques & Their Applications Using Matlab',
    image: SIMOMIMO, 
    link: 'https://www.researchgate.net/profile/Teshome-Ketema',
  },
  {
    title: 'Billiard balls detection, Watermarking, fire detection',
    description: 'Digital Image processing Using Matlab and Python',
    image: second,
    link: 'https://yourecommerceapp.com',
  },
  {
    title: 'Digital filter design',
    description: 'Communication and circuit analysis using Sonnet and ADS software',
    image: third,
    link: 'https://yoursocialmediadashboard.com',
  },
  {
    title: 'Programming on 8051 Microcontroller',
    description: 'Principle of the computer system Using Keil uvision and STC-ISP',
    image: fourth,
    link: 'httsps://yoursocialmediadashboard.com',
  },
  {
    title: 'Digital Logic Design 2020',
    description: 'Digital Logic and digital system design Using vivado design suit for the hardware FPGA implementation',
    image: fifth,
    link: 'https://yoursocialmediadashboard.com',
  },
  {
    title: 'Circuits experiments 1 and 2 and digital experiment 1 and 2',
    description: 'Electric Circuit Experment using Multisim software',
    image: six,
    link: 'https://yoursocialmediadashboard.com',
  },
];

const Mywork = () => {
  return (
    <div id='mywork' className="min-h-screen bg-gray-900 py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-white">My Work</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {works.map((work, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            >
              <img
                src={work.image}
                alt={work.title}
                className="w-full h-48 object-cover transition-transform duration-300 hover:scale-110"
              />
              <div className="p-6">
                <h2 className="text-2xl font-bold mb-2 text-gray-800">{work.title}</h2>
                <p className="text-gray-600 mb-4">{work.description}</p>
                <a
                  href={work.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline"
                >
                  MINI PROJECTS
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mywork;
